import { useCallback, useEffect, useMemo, useState } from 'react';
import { AxRoute } from 'src/features/DUP';
import { useRequest } from 'src/hooks/useResource';
import { SessionApplication, SessionProperty } from 'src/types/api';
import { ArgyleUser } from 'src/types/applicantExperienceApi';

export type ArgyleUserData = ReturnType<typeof useArgyleUser>;

const SNAPPT_PHONE_NUMBER = '18444762778';

export const useArgyleUser = ({
  activeStepIdx,
  connectedPayrollFeat,
  application,
  property
}: {
  activeStepIdx: number;
  connectedPayrollFeat?: { enabled: boolean };
  application?: SessionApplication;
  property?: SessionProperty;
}) => {
  const { makeRequest } = useRequest();

  const detailedUserPayload = useMemo(
    () =>
      application &&
      property && {
        firstName: application?.firstName,
        lastName: application?.lastName,
        phone: application?.phone,
        email: application?.email,
        property: {
          name: property?.name,
          address: property?.address,
          city: property?.city,
          state: property?.state,
          zip: property?.zip,
          phone: property?.phone || SNAPPT_PHONE_NUMBER
        }
      },
    [application, property]
  );

  const [argyleUser, setArgyleUser] = useState<ArgyleUser>();

  const getDetailedUser = useCallback(async () => {
    const res = await makeRequest<ArgyleUser>({
      path: `/${AxRoute.ARGYLE_V2}/users`,
      method: 'POST',
      payload: detailedUserPayload
    });
    if (res && 'userToken' in res) {
      setArgyleUser(res);
    }
  }, [makeRequest, detailedUserPayload]);

  useEffect(() => {
    if (connectedPayrollFeat && connectedPayrollFeat?.enabled) {
      if (activeStepIdx !== 0 && !argyleUser) {
        getDetailedUser();
      }
    }
  }, [activeStepIdx, argyleUser, connectedPayrollFeat, getDetailedUser]);

  return argyleUser;
};
